module.exports = __webpack_public_path__ + "files/02cb2a430a03d197123e89303f461e5f.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/ubuntu-italic-webfont.svg
 ** module id = 1030
 ** module chunks = 0
 **/